import { render, staticRenderFns } from "./CurrentAddressTip.vue?vue&type=template&id=82794d82&scoped=true&"
import script from "./CurrentAddressTip.vue?vue&type=script&lang=js&"
export * from "./CurrentAddressTip.vue?vue&type=script&lang=js&"
import style0 from "./CurrentAddressTip.vue?vue&type=style&index=0&id=82794d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../client_web_food_market/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82794d82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('82794d82', component.options)
    } else {
      api.reload('82794d82', component.options)
    }
    module.hot.accept("./CurrentAddressTip.vue?vue&type=template&id=82794d82&scoped=true&", function () {
      api.rerender('82794d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client_web_common/common_components/customerAddress/CurrentAddressTip.vue"
export default component.exports